import { Component, input, output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import {
  InsuranceFlowOption,
  InsuranceFlowSearchPurpose,
} from 'src/app/_types/insurance-flow.types';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { FlowSelectComponent } from 'src/app/shared/components/flow-select/flow-select.component';

/**
 * "Pick one of the member's affaires": an action modal around the affaire
 * picker, for the links a cancellation takes after its creation.
 *
 * Owns nothing but the pick. The host names what is being linked, scopes the
 * picker, does the request on `picked`, and closes the modal once it landed —
 * so an error keeps the pick on screen for another try.
 */
@Component({
  selector: 'app-link-flow-modal',
  standalone: true,
  imports: [ReactiveFormsModule, ActionModalComponent, FlowSelectComponent],
  templateUrl: './link-flow-modal.component.html',
  styleUrl: './link-flow-modal.component.css',
})
export class LinkFlowModalComponent {
  readonly title = input.required<string>();

  readonly subtitle = input('');

  /** The picker's label. */
  readonly label = input($localize`Affaire`);

  readonly submitLabel = input($localize`Lier`);

  readonly familyMemberId = input.required<string>();

  /** Keeps the picker inside one affaire; empty for any of the member's. */
  readonly displayId = input('');

  readonly excludeFlowId = input('');

  readonly withPolicyOnly = input(false);

  readonly insuranceType = input<InsuranceType | null>(null);

  readonly purpose = input.required<InsuranceFlowSearchPurpose>();

  /** The host's request is in flight: the buttons wait for it. */
  readonly busy = input(false);

  readonly picked = output<InsuranceFlowOption>();

  @ViewChild('modal')
  private readonly modal?: ActionModalComponent;

  protected readonly control = new FormControl<InsuranceFlowOption | null>(
    null
  );

  /**
   * The picker searches as soon as it exists, so it is only built while the
   * modal is up. Projected content is created with this view, not the modal's.
   */
  protected modalOpen = false;

  openModal(): void {
    this.control.reset(null);
    this.modalOpen = true;
    this.modal?.openModal();
  }

  closeModal(): void {
    this.modal?.closeModal();
  }

  protected submit(): void {
    const option = this.control.value;
    if (option) this.picked.emit(option);
  }

  protected onClosed(): void {
    this.modalOpen = false;
  }
}
